import React from 'react';
import {connect} from 'react-redux';
import cs from 'classnames';
import isEmpty from 'lodash/isEmpty';

import AccountHeader from '../share/AccountHeader';
import Chart from '../share/Chart';
import * as config from '../share/Chart/config';
import Spinner from '~/components/common/Spinner';
import mapDispatch from '~/misc/mapDispatch';
import store from '~/store';
import {getPaymentHistory, getPaymentNextBillDate} from '~/modules/paymentHistoryPage/actions';

import sharedCSS from '../share.css';

class PaymentHistory extends React.Component {
  constructor(props) {
    super(props);
    this.getHistory = this.getHistory.bind(this);
    this.getNextBillData = this.getNextBillData.bind(this);
  }

  componentDidMount() {
    store.dispatch((dispatch, getState) => getPaymentHistory(dispatch, getState));
    store.dispatch((dispatch, getState) => getPaymentNextBillDate(dispatch, getState));
  }

  render() {
    const accountInfo = this.props.adminAccountPage.accountInfo;
    const paymentHistory = this.props.paymentHistoryPage.paymentHistory;
    const paymentNextBillDate = this.props.paymentHistoryPage.paymentNextBillDate;

    if (isEmpty(accountInfo)) {
      return (<div className={cs(sharedCSS.tr, sharedCSS.viewH)}>
        <div className={sharedCSS.spinnerLine}>
          <div className={sharedCSS.spinner}>
            <Spinner scalable={true}/>
          </div>
        </div>
      </div>);
    }

    return (
      <div>
        <AccountHeader tit='Payment History' titleInfo='You can view, print and download your billing transactions.'/>
        <Chart chartData={paymentHistory} chartHeader={config.paymentHistory[0]} fn={this.getHistory} />
        <div className={cs(sharedCSS.subtitle)}>
          Next billing date:{' '}
          {/* {!isEmpty(paymentNextBillDate.data[0]) && paymentNextBillDate.data[0].next_billing_date} */}
        </div>
        <Chart chartData={paymentNextBillDate} chartHeader={config.nextbillingDay[0]} fn={this.getNextBillData} />
      </div>
    );
  }

  getNextBillData(e) {
    e.preventDefault();
    return store.dispatch((dispatch, getState) => getPaymentNextBillDate(dispatch, getState));
  }

  getHistory(e) {
    e.preventDefault();
    return store.dispatch((dispatch, getState) => getPaymentHistory(dispatch, getState));
  }
}
export default connect(({paymentHistoryPage}) => ({paymentHistoryPage}), mapDispatch({}))(PaymentHistory);





// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/PaymentHistory/index.js